import React from 'react';
import { useIntl } from 'react-intl';

import { getDocumentEditingIntegrations } from '~/common/constants/integrations';
import { useSearchParams } from '~/hooks/router';

import IntegrationCardList from './IntegrationCardList';

function DocumentEditingIntegrationCardList() {
  const [_, setTabValue] = useSearchParams('tab');
  const intl = useIntl();

  const integrationCards = Object.values(getDocumentEditingIntegrations()).map(
    (integration) => ({
      ...integration,
      enableStatusDetails: false,
      action: {
        onClick: () => setTabValue('third-party'),
        text: intl.formatMessage({
          id: 'DocumentEditingIntegrationCardList.seeIntegration',
          defaultMessage: 'See integration',
          description:
            'Button text to see the Document Editing integration details',
        }),
      },
    }),
  );

  return <IntegrationCardList integrationCards={integrationCards} />;
}

export default DocumentEditingIntegrationCardList;
